export default {
  slug: "fleet",
  code: "FL",
  label: "Fleet",
  krakenDir: "Fleet",
  logoFamily: "jb",
};
